import { render, staticRenderFns } from "./DrawerSkeleton.vue?vue&type=template&id=69e3d862&scoped=true&"
var script = {}
import style0 from "./DrawerSkeleton.vue?vue&type=style&index=0&id=69e3d862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e3d862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e3d862')) {
      api.createRecord('69e3d862', component.options)
    } else {
      api.reload('69e3d862', component.options)
    }
    module.hot.accept("./DrawerSkeleton.vue?vue&type=template&id=69e3d862&scoped=true&", function () {
      api.rerender('69e3d862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSelectionDrawer/components/DrawerSkeleton.vue"
export default component.exports